import groq from "groq"

export const tourScheduleProjection = () => groq`
  id,
  year,
  tour01,
  tour02,
  tour03,
  tour04,
  tour05,
  tour06,
  tour07,
  tour08,
  calendarWeek,
  creationAt,
  modifiedAt
`
